var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobeCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "globe-check",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92041 5.8C5.65625 3.49852 8.40401 2 11.5 2C15.9953 2 19.7748 5.144 20.7536 9.34707C20.0969 9.13914 19.4017 9.01949 18.682 9.00219C17.9636 6.92998 16.3748 5.27113 14.35 4.45479V4.85C14.35 5.89975 13.4998 6.75 12.45 6.75H10.55V8.65C10.55 9.1744 10.1244 9.6 9.6 9.6H8.65V11.5H12.9186C11.7267 12.8287 11 14.5825 11 16.5C11 18.1637 11.5471 19.7042 12.4704 20.9507C12.1513 20.9833 11.8275 21 11.5 21C6.26455 21 2 16.7355 2 11.5C2 9.37237 2.71246 7.41186 3.9 5.82598V5.8H3.92041ZM5.8 11.5L4.09668 9.79668C3.97175 10.3448 3.9 10.9131 3.9 11.5C3.9 15.3861 6.79348 18.5691 10.55 19.0351V17.2C9.50025 17.2 8.65 16.3498 8.65 15.3V14.35L5.8 11.5Z",
    fill: "#1237B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11C15.475 11 13 13.475 13 16.5C13 19.525 15.475 22 18.5 22C21.525 22 24 19.525 24 16.5C24 13.475 21.525 11 18.5 11ZM21.0674 14.0257L22.3493 15.3076L18.0417 19.617L15.109 16.6826L16.391 15.4007L18.0417 17.0496L21.0674 14.0257Z",
    fill: "#00C670"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeCheck);
export default __webpack_public_path__ + "static/media/globe-check.49d01db7.svg";
export { ForwardRef as ReactComponent };